module.exports = __webpack_public_path__ + "static/img/pay-jhm.7195308.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pay-jhm.png
// module id = y3b6
// module chunks = 1